import { Assinatura } from '@/services/types/pedidos';
import { Produto } from '@/types/produto';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { useEffect } from 'react';

export function useDesactivateOfferRedirect(props: {
  offer: Produto | Assinatura;
  router: AppRouterInstance;
}) {
  const { offer, router } = props;
  useEffect(() => {
    if (!offer) return;

    const { ativo = true } = offer;

    if (!ativo) {
      router.replace('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offer]);
}
